export default "__VITE_ASSET__DOVW5GIC__"